import React, { useRef, useState } from 'react';
import ENUMS from '../../enums/index';
import './introducedCafes.scss';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

const IntroducedCafesFilter = props => {
  let formRefrence = useRef();
  const radioRefYes = useRef();
  const radioRefNo = useRef();
  let [startDate, setStartDate] = useState();
  let [endDate, setEndDate] = useState();
  let [cafeCityName, setCafeCityName] = useState('');
  let [cafeAddress, setCafeAddress] = useState('');
  let [isCafeOwner, setIsCafeOwner] = useState();
  let [introducerName, setIntroducerName] = useState('');
  let [selectedBankPortalName, setSelectedBankPortalNames] = useState([]);
  let [amount, setAmount] = useState();
  let [introducerMobileNumber, setIntroducerMobileNumber] = useState();
  let [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);
  let [cafeName, setCafeName] = useState();
  const [error, setError] = useState();

  function handleEndDataChange(v) {
    if (startDate > v) {
      console.log(startDate, endDate, 'if');
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
      setEndDate(' ');
    } else {
      console.log(startDate, endDate, 'else');
      setError();
      setEndDate(v);
    }
  }

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setStartDate(' ');
    setEndDate(' ');
    setCafeAddress('');
    setIntroducerName('');
    setIntroducerMobileNumber();
    setCafeCityName('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex justify-content-between align-items-center px-1 my-2">
            <div className="d-flex flex-column mx-1 col-3 h-50 py-2">
              <input
                onChange={event => setIntroducerName(event.target.value)}
                value={introducerName || ''}
                name="introducerNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('messages.introducerName')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className="d-flex flex-column col-3 mx-1 h-50 py-2">
              <input
                onChange={event => setCafeName(event.target.value)}
                value={cafeName || ''}
                name="cafeNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('fields.cafe.name')}
                maxLength={ENUMS.MAX_LENGTH.cafeName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className="d-flex flex-column col-3 mx-1 h-50 pb-3">
              <input
                onChange={event => setIntroducerMobileNumber(event.target.value)}
                value={introducerMobileNumber || ''}
                name="cafePhoneNumberPart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.cafePhoneNumber')}
                maxLength={ENUMS.MAX_LENGTH.mobileNumber}
              />
              <small style={{ color: '#ccc' }}></small>
            </div>
            <div className="d-flex flex-column col-3 mx-1 h-50 pb-3">
              <input
                onChange={event => setCafeCityName(event.target.value)}
                value={cafeCityName || ''}
                name="cafeCityNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.cityName')}
                maxLength={ENUMS.MAX_LENGTH.city}
              />
              <small style={{ color: '#ccc' }}></small>
            </div>
          </div>
          <div className="d-flex justify-content-between px-1 my-4 align-items-center">
            <input
              onChange={event => setCafeAddress(event.target.value)}
              value={cafeAddress || ''}
              name="cafeAddressPart"
              type="text"
              className="form-control mx-2 col-8 h-50 py-2"
              placeholder={locales('messages.address')}
            />
            <div className="d-flex justify-content-center align-items-center">
              <label className="mx-2 m-0">{locales('labels.isCafeOwner')} ؟</label>
              {locales('labels.yes')}
              <input
                id="yes"
                onChange={event => setIsCafeOwner(true)}
                className="mx-2"
                value={isCafeOwner}
                name="isCafeOwner"
                type="radio"
                ref={radioRefYes}
              />
              {locales('labels.no')}
              <input
                id="no"
                name="isCafeOwner"
                className="mx-2"
                type="radio"
                value={isCafeOwner}
                ref={radioRefNo}
                onChange={event => setIsCafeOwner(false)}
              />
            </div>
          </div>
          <div className="d-flex col-6 justify-content-between p-0 align-items-center">
            از
            <DatePicker
              marge={true}
              name="startDate"
              className="form-control"
              value={startDate}
              onChange={v => setStartDate(v)}
              placeholder="تاریخ شروع"
            />
            تا
            <DatePicker
              marge={true}
              name="endDate"
              className="form-control"
              value={endDate}
              onChange={v => handleEndDataChange(v)}
              placeholder="تاریخ پایان"
            />
          </div>
          <div className="d-flex col-12 justify-content-between p-0 align-items-center">
            <div className="d-flex col-12 justify-content-between mx-1 py-2">
              <span className="col-2 text-center d-flex align-items-center">
                {locales('tables.status')} :{' '}
              </span>
              <div className="col-10 p-0 d-flex flex-wrap align-items-center">
                {ENUMS.INTRODUCED_CAFE_STATUS.list.map((introducedCafe, index) => (
                  <div
                    className={`col-${12 / ENUMS.INTRODUCED_CAFE_STATUS.list.length} d-flex p-0 mx-2`}
                    key={index}
                  >
                    <input
                      type="checkbox"
                      value={introducedCafe.value}
                      name={`status`}
                      id={`status-${index}`}
                      className="my-2"
                    />
                    <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                      {introducedCafe.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-cafe" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default IntroducedCafesFilter;
